module.exports = __webpack_public_path__ + "img/sl.62ace4d8.jpg";